import { render } from "./FundraisingAsideVue.vue?vue&type=template&id=24f7000c"
import script from "./FundraisingAsideVue.vue?vue&type=script&lang=js"
export * from "./FundraisingAsideVue.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__